import { billingContactName } from 'components/billingContacts/billingContactForm';
import { companyRoleLabel } from 'constants/companyRoles';
import UseContext from 'hooks/useContext';

/** The member a billing modal is about (mockup 8.4): name, email, role. */
const BillingMemberSummary = ({ member }) => {
  const { language } = UseContext();
  const role = companyRoleLabel(language, member?.role);

  return (
    <div
      className={
        'flex flex-col gap-0.5 rounded-md bg-gray-50 px-4 py-3 text-sm'
      }
      data-testid={'billing-member-summary'}
    >
      <span className={'text-gray-900 font-medium'}>
        {billingContactName(member) || member?.email}
      </span>
      <span className={'text-gray-700 break-words'}>{member?.email}</span>
      {role ? <span className={'text-gray-500'}>{role}</span> : null}
    </div>
  );
};

export default BillingMemberSummary;
